import { APIURL, postData, deleleData, getData } from "../fetch";


/**
 * 
 * @typedef {{
 * id: string,
 * client_id: string
 * code: string
 * title: string,
 * status: string
 * start_date: string
 * end_date: string 
 * billing_mode: number 
 * billing_cycle: number 
 * date_added: string
 * added_by: string
 * project: string|import("./projects").ProjectObject
 * }} ProjectObject 
 */




/**
 * 
 * @param {ProjectObject} data 
 * @returns {Promise<{code: number, message: string, project: ProjectObject}>}
 */
const createProject = (data) => {
    return postData({
        url: `${APIURL}/projects`,
        data
    })
}

/**
 * 
 * @param {ProjectObject} data 
 * @param {string} id
 * @returns {Promise<{code: number, message: string, project: ProjectObject}>}
 */
const updateProject = (data, id) => {
    return postData({
        url: `${APIURL}/projects/${id}`,
        data
    })
}

/**
 * 
 * @param {ProjectObject} data 
 * @returns {Promise<{code: number, message: string, projects: ProjectObject[]}>}
 */
const getProjects = (getAll = false, conditions = null) => {

    const obj = { url: `${APIURL}/projects`, data: {} }
    if (getAll) obj.data.expanded = 1;
    if (conditions) obj.data = { ...obj.data, ...conditions };

    return getData(obj);
}



/**
 * 
 * @param {string} id 
 * @param {string[]|null} includes 
 * @returns  {Promise<{code: number, message: string, project: ProjectObject}>}
 */
const getProject = (id, includes = null) => {

    const obj = { url: `${APIURL}/projects/${id}` };

    if (includes) obj.data = { include: includes.join(",") };

    return getData(obj);
}


/**
 * Delete a project
 * @param {string} id ID of the event
 * @returns  {Promise<{code: number, message: string}>}
 */
const deleteProject = id => deleleData({ url: `${APIURL}/projects/${id}` });


export {
    createProject,
    getProject,
    getProjects,
    updateProject,
    deleteProject
}